import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PromotionService, CntryBannerItemModel, AlertService } from '../../../services/index';

@Component({
  selector: 'account-detail',
  templateUrl: 'account-detail.html'
})
export class AccountDetailComponent {
  @Input() account: CntryBannerItemModel;
  @Input() accountCountries: Array<string>;
  @Input() isEditing:boolean;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() onSave: EventEmitter<any> = new EventEmitter();

  constructor(
    private promotionService: PromotionService,
    private alertService: AlertService,
  ) {}

  countrySelected(event) {
    if(event != null) {
      this.account.countryCode = event.cntryCd;
      this.account.countryName = event.cntryNm;
    }
  }

  close() {
    this.onClose.emit();
  }

  saveAccount() {
    if(this.isEditing) {
      this.promotionService.patchAccount(this.account).subscribe(
        resp => {
          if(resp.result) {
            this.alertService.success('구좌가 수정되었습니다.');
            this.onSave.emit();
          } else {
            this.alertService.error(resp.errorMsg);
          }
        }
      )
    } else {
      this.promotionService.postAccount(this.account).subscribe(
        resp => {
          if(resp.result) {
            this.alertService.success('구좌가 추가되었습니다.');
            this.onSave.emit();
          } else {
            this.alertService.error(resp.errorMsg);
          }
        }
      ); 
    }
  }
} 


// WEBPACK FOOTER //
// ./src/app/containers/promotion/account/account-detail.ts